import { render, staticRenderFns } from "./signSet.vue?vue&type=template&id=565cc984&scoped=true&"
import script from "./signSet.vue?vue&type=script&lang=js&"
export * from "./signSet.vue?vue&type=script&lang=js&"
import style0 from "./signSet.vue?vue&type=style&index=0&id=565cc984&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565cc984",
  null
  
)

export default component.exports